<template>
  <div>
    <h1>Lecture</h1>
    <div class="container-fluid mt-5 mb-5">
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <h4>Liste des articles</h4>
          <ul class="timeline">
            <li v-for="article in articles" :key="article.Id">
              <div style="width: 100%;display:flex;align-items:center;">
                <router-link class="title" target="_blank" :to="'/article/' + article.Id" style="width:80%;">{{article.Titre}}</router-link>
                <div class="categ">
                  <span>{{article.CategoryName}}</span>
                </div>
              </div>

              <p href="#" class="float-right date">{{formatDate(article.ModifiedDate)}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import { getArticles } from "@/utils/cms"
  export default {
    name: "CmsRead",
    components: {
    },
    data() {
      return {
        articles: [],//Liste des articles qui concernent l'utilisateur
      }

    },
    mounted() {
      getArticles().then(response => {
        this.articles = response;
      });
    },
    methods: {
      formatDate: function (dt) { //affiche la date sous le format ci-dessous 
        //21 mars 2020 à 09h24
        var tab_mois = new Array("Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre");
        const date = new Date(dt);
        var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        var month = tab_mois[date.getMonth() + 1];
        var day = date.getDate() + 1 < 10 ? '0' + date.getDate() : date.getDate();
        return (day + ' ' + month + ' ' + date.getFullYear() + ' à ' + hour + ':' + min)
      }
    }
  }
</script>

<style scoped>
  ul.timeline {
    list-style-type: none;
    position: relative;
  }

    ul.timeline:before {
      content: ' ';
      background: #40bd83;
      display: inline-block;
      position: absolute;
      left: 29px;
      width: 2px;
      height: 100%;
      z-index: 400;
    }

    ul.timeline > li {
      margin: 20px 0;
      padding-left: 20px;
    }
    ul.timeline li p{
        text-align:justify;
    }

    ul.timeline > li:before {
      content: ' ';
      background: white;
      display: inline-block;
      position: absolute;
      border-radius: 50%;
      border: 3px solid #198754;
      left: 20px;
      width: 20px;
      height: 20px;
      z-index: 400;
    }
      .date{
          font-size: 14px;
          color: #808080;
          font-style:italic;
          margin-top: 1%;
      }
  .title {
    font-size: 25px;
    padding: 10px;
    text-decoration: none;
    color: #2eae73;
    font-weight: bold;
  }
  .title:hover{
    color: #369f6e;

    text-decoration:underline;
  }
  .categ {
    width: 20%;
    padding: 10px;
    background-color: #198754;
    color: white;
    overflow-wrap: break-word;
    text-align: center;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Adherent/CmsRead.vue